import { signalStore, withState, withMethods, patchState, withComputed, withProps } from '@ngrx/signals';
import { computed, inject, resource } from '@angular/core';
import { AgencyUserGridService } from './agency-user-grid.service';

export const AgencyUserGridStore = signalStore(
  { providedIn: 'root' },
  withState<{filterValues: object}>({
    filterValues: <object>{},
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      filterValues: state?.filterValues?.(),
    })),
  })),
  withMethods((store) => ({
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
  })),
  withProps((store, agencyUserGridService = inject(AgencyUserGridService)) =>({
    resource: resource({
      params: store.filterValues,
      loader: async (request) => {
        const filter = request.params;
        const usersGrid = await agencyUserGridService.getAgencyUserGrid(filter);
        return usersGrid;
      }
    })
  }))
  );